import Vue from 'vue'
import Vuex from 'vuex'
import dimension from './modules/dimension'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: { dimension },
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: {}
  },
  mutations: {
    setToken(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    logout(state) {
      state.token = ''
      state.userInfo = {}
      localStorage.removeItem('token')
    }
  },
  actions: {
    login({ commit }, userInfo) {
      commit('setToken', userInfo.token)
      commit('setUserInfo', userInfo)
    }
  }
})
